export const SET_PENDING_BUSINESSES = 'SET_PENDING_BUSINESSES';
export const SET_REJECTED_BUSINESSES = 'SET_REJECTED_BUSINESSES';
export const SET_BUSINESS_PAGINATION = 'SET_BUSINESS_PAGINATION';
export const SET_REJECTED_PAGINATION = 'SET_REJECTED_PAGINATION';
export const SET_ALL_BUSINESSES = 'SET_ALL_BUSINESSES';
export const SET_ALL_BUSINESSES_PAGINATION = 'SET_ALL_BUSINESSES_PAGINATION';
